import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AdvancedDropdown } from "./AdvancedDropdown";

interface ScoringEditorHeaderProps {
  ruleCount: number;
  onAddRule: () => void;
  onOpenImport: () => void;
  onOpenExport: () => void;
  statusMessage?: string | null;
  errorMessage?: string | null;
}

export function ScoringEditorHeader({
  ruleCount,
  onAddRule,
  onOpenImport,
  onOpenExport,
  statusMessage,
  errorMessage,
}: ScoringEditorHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-lg font-semibold">Scoring-Regeln</h3>
        <p className="text-sm text-muted-foreground">
          {ruleCount} {ruleCount === 1 ? "Regel" : "Regeln"} konfiguriert
        </p>
      </div>
      <div className="flex items-center gap-3">
        {statusMessage && (
          <span className="text-sm font-medium text-green-700">
            {statusMessage}
          </span>
        )}
        {errorMessage && (
          <span className="text-sm text-red-600">Fehler: {errorMessage}</span>
        )}
        <Button type="button" size="sm" onClick={onAddRule}>
          <Plus className="mr-2 h-4 w-4" />
          Regel hinzufügen
        </Button>
        <AdvancedDropdown
          onOpenImport={onOpenImport}
          onOpenExport={onOpenExport}
        />
      </div>
    </div>
  );
}
